import { create } from 'zustand';
import type { ReportAnalysisPayload } from 'containers/Agent/agent.types';

export type ReportAnalysisTrigger = {
  reportData: ReportAnalysisPayload | null;
  timestamp: string | null;
  triggerType: string | null;
  chatId: string | null;
};

interface AgentStoreState {
  reportAnalysis: ReportAnalysisTrigger | null;
  finalAnswer: string | null;
  currentNodeName: string | null;
  setReportAnalysis: (reportAnalysis: ReportAnalysisTrigger | null) => void;
  clearReportAnalysis: () => void;
  setFinalAnswer: (finalAnswer: string) => void;
  clearFinalAnswer: () => void;
  setCurrentNodeName: (currentNodeName: string) => void;
  clearCurrentNodeName: () => void;
}

const INITIAL = {
  reportAnalysis: null,
  finalAnswer: null,
  currentNodeName: null,
} satisfies Partial<AgentStoreState>;

export const useAgentStore = create<AgentStoreState>((set) => ({
  ...INITIAL,
  setReportAnalysis: (reportAnalysis) => set({ reportAnalysis }),
  clearReportAnalysis: () => set({ reportAnalysis: null }),
  setFinalAnswer: (finalAnswer) => set({ finalAnswer }),
  clearFinalAnswer: () => set({ finalAnswer: null }),
  setCurrentNodeName: (currentNodeName) => set({ currentNodeName }),
  clearCurrentNodeName: () => set({ currentNodeName: null }),
}));

export const setFinalAnswer = (finalAnswer: string) =>
  useAgentStore.getState().setFinalAnswer(finalAnswer);

export const clearFinalAnswer = () =>
  useAgentStore.getState().clearFinalAnswer();

export const setCurrentNodeName = (nodeName: string) =>
  useAgentStore.getState().setCurrentNodeName(nodeName);

export const clearCurrentNodeName = () =>
  useAgentStore.getState().clearCurrentNodeName();

export const clearReportAnalysis = () =>
  useAgentStore.getState().clearReportAnalysis();

export const triggerReportAnalysis = (reportData: ReportAnalysisPayload) =>
  useAgentStore.getState().setReportAnalysis({
    reportData,
    timestamp: new Date().toISOString(),
    triggerType: 'GET_SUMMARY',
    chatId: `reports-summary-${Date.now()}`,
  });
